module.exports = __webpack_public_path__ + "static/media/codigoRExamenPrimerRegistro.b1d8ecef.r";